export const ecoregionColors = {
  a: '#D8AF46',
  b: '#92B6D8',
  c: '#68C7B8',
  d: '#C7687E',
  e: '#997FDE',
  u: '#8296A2'
}